export interface Messages {
  transaction: Transaction;
}

export class ContactInfo {
  contactId: string;
  firstName: string;
  lastName: string;

  constructor() {
    this.contactId = "";
    this.firstName = "";
    this.lastName = "";
  }
}

export class Transaction {
  transactionId: string;
  contactInfo: ContactInfo;
  senderId: string;
  senderUsername: string;
  updatedTimestamp: Date;
  destinationOriginal?: object;
  recipient: object;
  messageText: string;
  direction: number;
  timestamp: string;
  senderAddress: string;
  type: string;

  constructor() {
    this.transactionId = "";
    this.contactInfo = new ContactInfo();
    this.senderId = "";
    this.senderUsername = "";
    this.updatedTimestamp = new Date();
    this.recipient = {};
    this.messageText = "";
    this.direction = 0;
    this.timestamp = "";
    this.senderAddress = "";
    this.type = "";
  }
}

export enum MESSAGE_INBOUND_TYPE {
  SOS_ALERT = "SOS_ALERT",
  SOS_ALERT_UPDATE = "SOS_ALERT_UPDATE",
  NEW_INBOUND_MESSAGE = "NEW_INBOUND_MESSAGE",
}
